import React from "react";
import {useAppContext} from "@/contexts/app";

export default function Header() {
    const {appTitle} = useAppContext();
    return (
        <div className="bg-white border-bottom p-3 d-flex justify-content-between align-items-center fixed-top pe-5" style={{
            left: "56px",
            right: 0,
            height: "56px",
            transition: "left 0.3s ease-in-out",
            zIndex: 2
        }}>
            <div className="d-flex align-items-center gap-1">
                <span className="text-muted">{appTitle}</span>
            </div>
        </div>
    );
}

